import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { executeApiAction } from '../../shared/utility/apiHelper';
import { getPortalDashboardSummary } from '../services/evidenceService';
import { getClearanceLevelInt } from '../utility/evidenceClearanceHelper';
import { PORTAL_DASHBOARD_SUMMARY_DEFAULT } from '../constants/evidencePortalConstants';

// Portal-only counterpart to useMyDashboardSummary: fetches the SubmittedBy/CollectedBy/
// ReceivedBy-scoped summary (matching the reference Evidence Management portal) instead of
// the Main Dashboard's SubmittedBy-only summary.
const usePortalDashboardSummary = () => {
  const dispatch = useDispatch();
  const agencyId = useSelector((state) => state.user?.userAgency);
  const personId = useSelector((state) => state.user?.userData?.user?.ptsPersonID);
  const personLabel = useSelector(
    (state) => state.user?.userData?.user?.FullName || state.user?.userData?.user?.Username
  );
  const userCurrentClearanceLevel = useSelector((state) => state.user?.userCurrentClearanceLevel);
  const clearanceLevel = useMemo(() => getClearanceLevelInt(userCurrentClearanceLevel), [
    userCurrentClearanceLevel,
  ]);

  const [summary, setSummary] = useState(PORTAL_DASHBOARD_SUMMARY_DEFAULT);
  const [summaryLoading, setSummaryLoading] = useState(false);

  const loadSummary = useCallback(() => {
    if (!agencyId || !personId) return;

    executeApiAction({
      setLoading: setSummaryLoading,
      dispatch,
      action: () => getPortalDashboardSummary(agencyId, personId, clearanceLevel),
      onSuccess: (response) => setSummary(response || PORTAL_DASHBOARD_SUMMARY_DEFAULT),
    });
  }, [agencyId, personId, clearanceLevel, dispatch]);

  useEffect(() => {
    loadSummary();
  }, [loadSummary]);

  return { summary, summaryLoading, personId, personLabel, refetchSummary: loadSummary };
};

export default usePortalDashboardSummary;
